export enum SortFields {
  name = 'name',
  date = 'created_at',
}

export interface ISortState {
  fieldName: SortFields,
  asc: boolean,
}
